import Quill from "quill";

const ListItemBlot = Quill.import("formats/list/item");

class ListItem extends ListItemBlot {

  // optimize(context) {
  //   super.optimize(context);

  //   if (this.children.length === 1) {
  //     const child = this.children.head;
  //     const attributes = child.attributes;

  //     if (attributes && attributes.attributes.color) {
  //       const color = attributes.attributes.color.value(child.domNode);
  //       super.format('custom-color', color);
  //     }
  //   } else {
  //     if (this.attributes.attributes.hasOwnProperty('custom-color')) {
  //       super.format('custom-color', null);
  //     }
  //   }
  // }

  format(name, value) {
    super.format(name, value);

    if (name == 'listItemColor') {
      super.format('lineColor', value);
    } else if (name == 'listItemFontFamily') {
      super.format('lineFontFamily', value);
    }
  }
}

export default ListItem;
